import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEye, faTrash,faDownload } from '@fortawesome/free-solid-svg-icons';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import { Box, CircularProgress, MenuItem, Select, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import { useNavigate, useParams } from 'react-router-dom';

import { IoArrowBack } from "react-icons/io5";

import { useState ,useEffect, useMemo } from "react";

import { Report } from '../vouchers_report/Vouchers_report';
import TablePaginationActions from '../../../../base-components/TablePaginationActions';
import ExportDropdownMenu from '../../../../base-components/ExportDropdownMenu';
import { Pie } from 'react-chartjs-2';
import { Reportinvoice } from './Reportinvoice';
import dayjs from 'dayjs';
import { isDynamicStaffRole } from '../../../../utils/roleAccess';
import { PageHeader } from '../../../../ui';

const BASE_URL = process.env.REACT_APP_BASE_URL;
function InvoiceReport() {
    const navigate = useNavigate()
    //states for this page
    const [loading , setLoading] = useState(false)
    const [vouchers , setVouchers] = useState([])
    //roles and permission states
    const [role , setRole] = useState('')
    const [location_id , setLocationID] = useState('')
    const [company_id , setCompanyID] = useState('')
    const [member_id , setMemberID] = useState('')
    //pagintion states
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page , setPage ] = useState(0)
    const [filtered_vouchers, setFilteredVouchers] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [status, setStatus] = useState("All");
    
    const [VoucherType, setSubscriptionType] = useState("");
    const [paymentFromDate, setPaymentFromDate] = useState(""); 
    const [paymentToDate, setPaymentToDate] = useState("");  
    const [dueFromDate, setDueFromDate] = useState("");
    const [dueToDate, setDueToDate] = useState("");
    const [searchQuery, setSearchQuery] = useState(""); 
    // const [totalRecieved , setTotalRecieved] = useState(0)
    // const [totalDiscount , setTotalDiscount] = useState(0)

    useEffect(()=> {
        const sessionStr = sessionStorage.getItem('user-info');
        if(sessionStr){
            const session = JSON.parse(sessionStr);
            setRole(session.user.role)
            setCompanyID(session.user.company_id)
            setLocationID(session.user.location_id)
            setMemberID(session.user.member_id)
        }
        else {
            navigate('/login');
        }
    },[])

    // useEffect(() => {
    //     setLoading(true)
    //     if(role) {
    //     getVouchers()
    //     setTimeout(()=> {
    //         setLoading(false)
    //     } , 1000)
    //     }
    // }, [role]);
//   useEffect(() => {
//       const fetchVouchers = async () => {
//         setLoading(true);
//         if (role) {
//           await getVouchers(); 
//           setLoading(false);       
//         }
//       };
    
//       fetchVouchers();
//     }, [role]);
const getVouchers = async (start , end) => {
    if (!role) return [];
    let endpoint = '';
    if (role === 'SuperAdmin') {
        endpoint = ``;
    } else if (role === 'Admin') {
        endpoint = `voucher/getVouchersByCompanyID/${company_id}?start=${start}&end=${end}`;
    } else if (role === 'ClubAdmin') {
        endpoint = `voucher/getAllVouchersByLocationID/${location_id}?start=${start}&end=${end}`;
    } else if (isDynamicStaffRole(role)) {
        endpoint = `voucher/getAllVouchersByLocationID/${location_id}?start=${start}&end=${end}`;
    }

    try {
        const response = await fetch(BASE_URL + endpoint);
        const data = await response.json();
        const allVouchers = data.vouchers;

        setVouchers(allVouchers);
        setFilteredVouchers(allVouchers);

        // const recieved = allVouchers.reduce((sum, voucher) => sum + (voucher.paid_amount || 0), 0);
        // const discount = allVouchers.reduce((sum, voucher) => sum + (voucher.invoice?.discount || 0), 0);

        // setTotalRecieved(recieved);
        // setTotalDiscount(discount);

        return allVouchers; // 🔥 return vouchers here
    } catch (error) {
        console.log(error);
        return [];
    }
};
    console.log("id",vouchers)
    const paginatedVouchers = !filtered_vouchers || filtered_vouchers.length === 0 ?
    [] :
     rowsPerPage === -1
    ? filtered_vouchers // Show all if "All" option is selected
    : filtered_vouchers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };
      const handleDownload=()=>{
          Reportinvoice(filtered_vouchers)
      }

      // Detect if filters are applied
      const hasFiltersApplied = useMemo(() => {
        return fromDate || toDate || searchQuery || status !== 'All' || VoucherType || paymentFromDate || paymentToDate || dueFromDate || dueToDate;
      }, [fromDate, toDate, searchQuery, status, VoucherType, paymentFromDate, paymentToDate, dueFromDate, dueToDate]);

      // Export handlers
      const handleExportAll = () => {
        Reportinvoice(vouchers);
      };

      const handleExportWithFilters = () => {
        Reportinvoice(filtered_vouchers);
      };

      const handleExportCurrentView = () => {
        const currentPageData = paginatedVouchers;
        Reportinvoice(currentPageData);
      };
    const handleSearch = (search) => {
        setSearchQuery(search);
        let filteredvoucher = [];
        if(search === '') {
        setFilteredVouchers(vouchers);
        }
        else {
        filteredvoucher  = vouchers.filter((voch) => {
            const combinedMemberID = `${voch?.location_id?.member_id_temp}${voch?.member_id?.member_id}`.toLowerCase();
                return (
                    (voch.invoice_no.toLowerCase()?.includes(search.toLowerCase())) || 
                    (voch.voucher_type.toLowerCase()?.includes(search.toLowerCase())) ||
                    (combinedMemberID?.includes(search.toLowerCase())) ||
                    (voch.member_id.name.toLowerCase()?.includes(search.toLowerCase())) 
                )
            });
            setFilteredVouchers(filteredvoucher);
        }
    }; 

    const handleStatusChange = (value) => {
        setStatus(value);
        if(value === 'Paid'){
            setFilteredVouchers(vouchers.filter(voucher => voucher.invoice?.is_paid === true || voucher.receipt))
        }else if(value === 'Unpaid'){
            setFilteredVouchers(vouchers.filter(voucher => voucher.invoice?.is_paid === false))
        }else if(value === 'All') {
            setFilteredVouchers(vouchers)
        }
    }
  
    const handleFilter = async () => {
        setLoading(true);
        let filtered = filtered_vouchers; 
        console.log(filtered);
    
        
        if (fromDate && toDate) {
            const startFilterDate = new Date(fromDate);
            startFilterDate.setHours(0,0,0,0)
            const endFilterDate = new Date(toDate);
            endFilterDate.setHours(23,59,59,999)

            const vouchers = await getVouchers(startFilterDate , endFilterDate);
            filtered = vouchers;
            console.log('filtered: ' , filtered);
            
            // filtered = filtered_vouchers;
            // filtered = filtered.filter(voucher => {
            //     const voucherDate = new Date(voucher.voucher_date);
            //     return voucherDate >= startFilterDate && voucherDate <= endFilterDate;
            // });
        }
        if (paymentFromDate && paymentToDate) {
            const startPaymentDate = new Date(paymentFromDate);
            const endPaymentDate = new Date(paymentToDate);
        
            filtered = filtered.filter(voucher => {
                if(voucher.receipt){
                
                const paymentDate = voucher.voucher_date ? new Date(voucher.voucher_date) : null;
                    return  paymentDate >= startPaymentDate && paymentDate <= endPaymentDate;
                }else {
                    const paymentDate = voucher?.invoice?.payment_date ? new Date(voucher.invoice.payment_date) : null;
                    return paymentDate && paymentDate >= startPaymentDate && paymentDate <= endPaymentDate;
                }
            });
        }

        if (dueFromDate && dueToDate) {
            const startDueDate = new Date(dueFromDate);
            const endDueDate = new Date(dueToDate);
        
            filtered = filtered.filter(voucher => {
                const invoiceDueDate = voucher?.invoice?.due_date ? new Date(voucher.invoice.due_date) : null;
                const receiptDueDate = voucher?.receipt?.due_date ? new Date(voucher.receipt.due_date) : null;
        
                console.log("Voucher ID:", voucher._id);
                console.log("Invoice Due Date:", invoiceDueDate);
                console.log("Receipt Due Date:", receiptDueDate);
                
                return (
                    (invoiceDueDate && invoiceDueDate >= startDueDate && invoiceDueDate <= endDueDate) ||
                    (receiptDueDate && receiptDueDate >= startDueDate && receiptDueDate <= endDueDate)
                );
            });
        }
        if (VoucherType) {
            filtered = filtered.filter(voucher => 
                voucher.voucher_type.toLowerCase() === VoucherType.toLowerCase()
            );
        }
    
        console.log("Filtered Vouchers:", filtered);
        setFilteredVouchers(filtered);
        
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };
    
      const handleClear = () => {
        setLoading(true); 
        setFilteredVouchers(vouchers); 
    
        
        setFromDate("");
        setToDate("");
        setStatus("");
       
        setSubscriptionType("");
        setDueFromDate("");
        setDueToDate("");
        setPaymentFromDate("");
        setPaymentToDate("");
    
        
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      };
  return (
    <>
        {/* <div className='flex items-center justify-end my-2 mx-3'>
            <div className='text-blue-800 hover:cursor-pointer hover:text-blue-900'>
                <Tooltip title='Download' arrow>
                <FontAwesomeIcon icon={faDownload} fontSize='30px' onClick={handleDownload}/>
                </Tooltip>
            </div>
        </div> */}
          <div className="m-5 print:hidden">
            <PageHeader
              title="Member Invoices"
              actions={
                <ExportDropdownMenu
                  onExportAll={handleExportAll}
                  onExportWithFilters={handleExportWithFilters}
                  onExportCurrentView={handleExportCurrentView}
                  hasFiltersApplied={hasFiltersApplied}
                />
              }
            />
          </div>

        <div className='flex items-center justify-start gap-10 '>
            <div className=" my-3 mx-2 md:mx-8 relative">
                <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => handleSearch(e.target.value)}
                    className="border border-gx-border rounded-md py-1 px-2 pl-10 outline-0 w-full md:w-72"
                />
                <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-2 text-gx-ink-soft" />
            </div>
    
            <div className=" flex justify-center items-center w-full gap-2">
                <label className="text-gx-ink gap-8 font-semibold">Filter:</label>
                <Select value={status} onChange={(e) => handleStatusChange(e.target.value)}
                    className="w-[250px] bg-white h-9"
                    >
                    <MenuItem value={'All'}>All</MenuItem>
                    <MenuItem value={'Paid'}>Paid</MenuItem>
                    <MenuItem value={'Unpaid'}>Unpaid</MenuItem>
                </Select>
            </div>
        </div>
        
            <div className="p-4 mx-4">
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className="w-full flex items-center justify-start gap-8">
                        <div className="flex items-center gap-2">
                            <label className="text-gx-ink gap-8 font-semibold">From Date:</label>
                            <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            className="border border-gx-border rounded-md py-1 px-3 outline-0 text-gx-ink-soft w-48"
                            />
                        </div>
                    
                        <div className="flex items-center gap-2">
                            <label className="text-gx-ink font-semibold">End Date:</label>
                            <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            disabled={!fromDate} 
                            min={fromDate}
                            className="border border-gx-border rounded-md py-1 px-3 outline-0"
                            />
                        </div>
                        <div className='flex items-center  gap-1'>
                            <button onClick={handleFilter} className="bg-green-700 text-white hover:bg-green-800 py-1 px-2 rounded-md flex items-center gap-2">
                                Fetch Invoices
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        {
             loading ? (
                
                  <div className="flex justify-center items-center mt-20 relative">
                    {/* SVG Gradient Definition */}
                    <svg width="0" height="0">
                      <defs>
                        <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#D71920" />
                          <stop offset="100%" stopColor="#F7931E" />
                        </linearGradient>
                      </defs>
                    </svg>
            
                    {/* Circular Progress with Gradient Stroke */}
                    <CircularProgress
                      thickness={4}
                      size={35}
                      sx={{
                        'svg circle': {
                          stroke: 'url(#gradientColors)', // Apply gradient stroke
                        },
                      }}
                    />
                  </div>
                
              ) : (
                filtered_vouchers && filtered_vouchers.length !== 0 ? (     
            <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto  overflow-x-auto">
                <Table>
                  <TableHead>
                      <TableRow >
                          <TableCell>Voucher No</TableCell>
                          <TableCell>Member Id</TableCell>
                          <TableCell>Member Name</TableCell>
                          <TableCell>Contact No</TableCell>
                          <TableCell>Issue Date</TableCell>
                          <TableCell>Due Date</TableCell>
                          <TableCell>Paid Date</TableCell>
                          <TableCell>Due Amount</TableCell>
                          <TableCell>Discount</TableCell>
                          <TableCell>Voucher Type</TableCell>
                          <TableCell>Paid Amount</TableCell>
                          <TableCell>Payment Reference</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Actions</TableCell>
                      </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      paginatedVouchers.map((voucher , index) => (
                            voucher?.voucher_type === 'Invoice' ?
                                (<TableRow hover key={index}>
                                    <TableCell>{voucher?.invoice_no}</TableCell>
                                    {/* <TableCell>{voucher?.member_id?.member_id}</TableCell> */}
                                    <TableCell>
                                        {`${voucher?.location_id?.member_id_temp ?? ''}${voucher?.member_id?.member_id ?? ''}`}
                                    </TableCell>
                                    <TableCell>{voucher?.member_id?.name}</TableCell>
                                    <TableCell>{voucher?.member_id?.phone}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher.voucher_date).format('MMM DD, YYYY') 
                                        : ''}</TableCell>
                                    <TableCell>{voucher?.invoice?.due_date ? dayjs(voucher.invoice.due_date).format('MMM DD, YYYY') 
                                        : ''}</TableCell>
                                    <TableCell>{voucher?.invoice?.payment_date ? dayjs(voucher?.invoice?.payment_date).format('MMM DD, YYYY') 
                                        : ''}</TableCell>
                                    <TableCell>Rs {voucher?.invoice?.total_amount}</TableCell>
                                    <TableCell>{voucher?.invoice?.discount || 0}</TableCell>
                                    <TableCell>{voucher?.voucher_type || 0}</TableCell>
                                    <TableCell>Rs {voucher?.paid_amount || 0}</TableCell>
                                    <TableCell>{voucher?.reference_number || '—'}</TableCell>
                                    <TableCell>{voucher?.invoice?.payment_status || 'Expired'}</TableCell>
                                    <TableCell>
                                        <div className='flex gap-2'>
                                            <div className='flex items-center justify-center gap-2'>
                                                <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-green-700' onClick={()=> navigate(`/voucher/${voucher?._id}`)}>
                                                    <FontAwesomeIcon icon={faEye}/> View
                                                </div>
                                                {/* <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-green-700' onClick={()=> navigate(`/transactions?voucher_id=${voucher?._id}`)}>
                                                    {'Transactions>>'}
                                                </div> */}
                                            </div>
                                        </div>
                                    </TableCell>
                                </TableRow>) : (
                                    voucher?.voucher_type === 'Receipt' ? 
                                    (<TableRow>
                                    <TableCell>{voucher?.invoice_no}</TableCell>
                                    {/* <TableCell>{voucher?.member_id.member_id}</TableCell> */}
                                    <TableCell>
                                        {`${voucher?.location_id?.member_id_temp ?? ''}${voucher?.member_id?.member_id ?? ''}`}
                                    </TableCell>
                                    <TableCell>{voucher?.member_id.name}</TableCell>
                                    <TableCell>{voucher?.member_id?.phone}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher?.voucher_date).format('MMM DD, YYYY') 
                                        : ''}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher?.voucher_date).format('MMM DD, YYYY') 
                                        : ''}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher?.voucher_date).format('MMM DD, YYYY') 
                                        : ''}</TableCell>
                                    <TableCell>Rs {voucher?.paid_amount || '- - - '}</TableCell>
                                    <TableCell>{voucher?.receipt?.discount || 0}</TableCell>
                                    <TableCell>{voucher?.voucher_type || 0}</TableCell>
                                    <TableCell>Rs {voucher?.paid_amount || 0}</TableCell>
                                    <TableCell>{voucher?.reference_number || '—'}</TableCell>
                                    <TableCell>Paid</TableCell>
                                    <TableCell>
                                        <div className='flex gap-2'>
                                            <div className='flex items-center justify-center gap-2'>
                                                <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-green-700' onClick={()=> navigate(`/recipt/${voucher?._id}`)}>
                                                    <FontAwesomeIcon icon={faEye}/> View
                                                </div>
                                                {/* <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-green-700' onClick={()=> navigate(`/transactions?voucher_id=${voucher?._id}`)}>
                                                    {'Transactions>>'}
                                                </div> */}
                                            </div>
                                        </div>
                                    </TableCell>
                                    </TableRow>): null
                                )
                                    
                            ))
                    }
                  </TableBody>
                  <TableFooter>
                      <TableRow>
                      <TablePagination
                          rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                          colSpan={12}
                          count= {filtered_vouchers.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          slotProps={{
                              select: {
                              inputProps: {
                                  'aria-label': 'rows per page',
                              },
                              native: true,
                              },
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                          />
                      </TableRow>
                  </TableFooter>
              </Table>
            </Box>
            ) : (
              <div className='bg-gx-border w-ful p-3 mt-10 rounded-lg m-10'>
                <h3 className='text-xl font-bold text-center text-gx-ink-soft'>No Records Found</h3>
              </div>
            )
        )
          }
    </>
  )
}

export default InvoiceReport